import { useMemo } from 'react';
import { Paragraph } from 'theme-ui';
import { useProductByHandle } from '@backpackjs/storefront';

import { Link, Picture } from '@snippets';

import { themed } from './CollectionCategoriesDesktop.theme';

export const CollectionCategoriesDesktopItem = themed(
  ({ item, collectionHandle, theme, ...props }) => {
    const productHandle = item.mobileImage?.product?.handle;
    const manualSrc = item.mobileImage?.image?.src;

    const { product } = useProductByHandle({
      handle: productHandle,
    });

    const firstImage = useMemo(() => {
      return product?.media?.find((item) => {
        return item.mediaContentType === 'IMAGE';
      })?.image;
    }, [product?.id]);

    const isActive = useMemo(
      () => item.link?.url?.split('/').pop() === collectionHandle,
      [item.link?.url, collectionHandle]
    );

    return (
      <Link
        data-comp={CollectionCategoriesDesktopItem.displayName}
        href={item.link?.url}
        newTab={item.link?.newTab}
        tabIndex={props.tabIndex || '0'}
        aria-hidden={props['aria-hidden'] || 'false'}
        sx={theme.item(isActive).link}
      >
        <Picture
          alt={item.link?.text}
          images={[
            {
              src: firstImage?.originalSrc,
              width: 40,
              ratio: 1,
            },
          ]}
          sx={theme.item(isActive).picture}
          imageSx={{
            objectFit: manualSrc ? 'cover' : 'contain',
          }}
        />

        <Paragraph sx={theme.item(isActive).label}>{item.link?.text}</Paragraph>
      </Link>
    );
  }
);

CollectionCategoriesDesktopItem.displayName = 'CollectionCategoriesDesktopItem';
